//#region Libraries
import styled from "styled-components";
//#endregion

export const ContainerForm = styled.section`
	display: flex;
	flex-direction: column;
	gap: 10px;
	justify-content: space-between;
	min-height: var(--min-height-without-header);
`;
export const ContentForm = styled.section`
	width: 100%;
	padding: 20px;
`;
export const TitleForm = styled.h2`
	font-size: 20px;
	font-weight: 600;
	margin: 0;
	margin-top: ${({ marginTop = "15px" }) => marginTop};
	text-align: center;
`;
export const ContainerParts = styled.section`
	display: flex;
	flex-direction: column;
	gap: 15px;
	align-self: center;
	width: 100%;
`;
export const Row = styled.div`
	display: flex;
	justify-content: ${({ justifyContent = "space-between" }) =>
		justifyContent};
	align-items: ${({ align = "center" }) => align};
	flex-wrap: ${({ wrap = "wrap" }) => wrap};
	gap: ${({ gap = "15px" }) => gap};
	${({ rowGap }) => (rowGap ? `row-gap: ${rowGap};` : "")}
	${({ columnGap }) => (columnGap ? `column-gap: ${columnGap};` : "")}
    width: ${({ width = "unset" }) => width};
	max-width: ${({ maxWidth = "unset" }) => maxWidth};
	min-width: ${({ minWidth = "unset" }) => minWidth};
	margin-bottom: ${({ marginBottom = 0 }) => marginBottom};
	margin-top: ${({ marginTop = 0 }) => marginTop};
	margin-left: ${({ marginLeft = 0 }) => marginLeft};
	margin-right: ${({ marginRight = 0, marginLeft }) =>
		marginRight || marginLeft};
	&.wrap {
		flex-wrap: wrap;
	}
	&.flex-start {
		justify-content: flex-start;
	}
	&.center {
		justify-content: center;
	}
`;
export const Column = styled.div`
	display: flex;
	flex-direction: column;
	min-width: ${({ minWidth = "200px" }) => minWidth};
	width: ${({ width = "100%" }) => width};
	min-height: ${({ minHeight = "unset" }) => minHeight};
	height: ${({ height = "unset" }) => height};
	max-height: ${({ maxHeight = "unset" }) => maxHeight};
	gap: ${({ gap = "15px" }) => gap};
	flex-grow: ${({ grow }) => grow || "unset"};
	${({ rowGap }) => (rowGap ? `row-gap: ${rowGap};` : "")}
	${({ columnGap }) => (columnGap ? `column-gap: ${columnGap};` : "")}
    margin-bottom: ${({ marginBottom = 0 }) => marginBottom};
	margin-top: ${({ marginTop = 0 }) => marginTop};
	padding: ${({ padding = "unset" }) => padding};
	align-items: ${({ align = "flex-start" }) => align};
	align-self: ${({ alignSelf = "unset" }) => alignSelf};
	overflow-y: ${({ overflowY = "visible" }) => overflowY};
`;
export const Part = styled.section`
	display: flex;
	flex-direction: ${({ direction = "column" }) => direction};
	flex-wrap: wrap;
	gap: ${({ gap = "10px" }) => gap};
	width: 100%;
	padding: 32px;
	border-radius: 8px;
	padding-bottom: ${({ paddingBottom = "30px" }) => paddingBottom};
	background-color: var(--light-1);
`;
export const TitleView = styled.h2`
	font-size: 24px;
	text-align: ${({ textAlign = "unset" }) => textAlign};
	margin: ${({ margin = "5px 0" }) => margin};
`;
export const TitleSection = styled.h3`
	font-size: 19px;
	text-align: ${({ textAlign = "unset" }) => textAlign};
	margin: ${({ margin = "5px 0" }) => margin};
	font-weight: ${({ fontWeight = "600" }) => fontWeight};
	width: ${({ width = "300px" }) => width};
	&.ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	@media (max-width: 500px) {
		width: unset;
		text-overflow: hidden;
	}
`;
export const TitleSection2 = styled.h3`
	font-size: 18px;
	margin: 5px 0;
	margin-bottom: 10px;
	font-weight: 600;
	color: var(--light-gray-5);
`;
export const SubtitleSection = styled.h4`
	margin: ${({ margin = 0 }) => margin};
	text-align: ${({ align = "unset" }) => align};
	font-weight: ${({ fontWeight = "600" }) => fontWeight};
	font-size: ${({ fontSize = "14px" }) => fontSize};
`;
export const ParagraphSection = styled.p`
	margin: 0;
	color: var(--light-gray-5);
	font-size: 14px;
	&.secondary {
		color: var(--dark-4);
	}
`;
export const Fields = styled.section`
	display: flex;
	flex-direction: column;
	gap: 30px;
	margin-top: 20px;
	padding-bottom: 40px;
`;
export const BottomPart = styled.footer`
	display: flex;
	justify-content: space-between;
	gap: 10px;
`;
export const ResumeSection = styled.section`
	background-color: var(--light-blue-2);
	padding: 30px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	gap: 15px;
	width: 100%;
`;
export const FooterFormManualLoading = styled.footer`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 15px;
	padding: 20px 32px;
	margin-top: ${({ marginTop = "90px" }) => marginTop};
	background-color: var(--light-1);
	& > div {
		display: flex;
		gap: 15px;
		align-items: center;
		flex-wrap: wrap;
	}
`;
export const HelperText = styled.span`
	color: var(--light-gray-2);
	font-size: 14px;
	font-weight: 490;
`;
export const LinkA = styled.a`
	max-width: ${({ maxWidth = "200px" }) => maxWidth};
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 100%;
	color: var(--light-blue-5);
	font-size: 14px;
	&.disabled {
		color: var(--purple-4);
		pointer-events: none;
	}
`;
export const SmallMessage = styled.span`
	color: var(--dark-4);
	font-size: 12px;
`;
export const Tooltip = styled.h6`
	color: var(--light-1);
	background-color: var(--dark-3);
	display: grid;
	place-items: center;
	padding: 13px;
	border-radius: 6px;
	width: ${({ width = "max-content" }) => width};
	height: ${({ height = "unset" }) => height};
	position: ${({ position = "absolute" }) => position};
	font-size: 14px;
	font-weight: ${({ weight = 400 }) => weight};
	z-index: 3;
	top: ${({ top = 0 }) => top};
	left: ${({ left = 0 }) => left};
	transform: translate(${({ x = "-45%", y = "-240%" }) => `${x}, ${y}`});
	opacity: 0;
	visibility: hidden;
	transition: opacity 0.35s, visibility 0.35s;
	&.active {
		visibility: visible;
		opacity: 1;
	}
	&::after {
		content: attr(div);
		border: 10px solid var(--dark-3);
		border-top-color: transparent;
		border-left-color: transparent;
		border-radius: 3.5px;
		position: absolute;
		transition: opacity 0.35s, visibility 0.35s;
		top: 78%;
		left: 50%;
		transform: ${({
			after = {
				x: "-50%",
				y: "-10%",
				angle: "45deg",
			},
		}) => {
			return `translate(${after.x}, ${after.y}) rotate(${after.angle})`;
		}};
	}
	& span.ellipsis {
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;
export const ButtonLink = styled.span`
	--color: var(--purple-2);
	color: var(--color);
	font-weight: bold;
	font-size: 14px;
	line-height: 12px;
	width: max-content;
	border-bottom: 1.5px solid var(--color);
	transition: 0.3s;
	margin-top: 15px;
	${({ margin }) => margin && `margin: ${margin};`}
	cursor: pointer;
	&:hover {
		--color: var(--purple-3);
	}
	&.error {
		--color: var(--red-2);
	}
	&.disabled {
		--color: var(--purple-4);
		pointer-events: none;
	}
`;
export const RequiredAsterisk = styled.span`
	color: var(--red-3);
	font-weight: bold;
`;
